/**
 * @param {{obj?: object | null}} props
 * @return {JSX.Element}
 */
export function JSONDisplay(props) {
  if (!props.obj) {
    return <></>
  }
  return <pre>{JSON.stringify(props.obj, null, 4)}</pre>
}
